import { UserAccessBadge } from '../hooks/useAccessBadge';

// Whether the user may manage the org they're in: invite, change or remove members,
// Students/SSO settings, the school library. The API checks their own role in the org,
// `organization.role`. The top-level `role` lifts district admins to Admin in every
// school, so it is only the fallback for a badge without `organization.role`: a tenant
// with no organization (nothing to lift from, so `role` is their own), or a badge from
// an API that predates the field.
export const canManageOrg = (badge?: Pick<UserAccessBadge, 'role' | 'organization'>) =>
  (badge?.organization?.role ?? badge?.role) === 'Admin';
